import {
  clearProperty,
  setProperty,
} from "../../packages/common-utilities/utils/misc";
import { getAllDepartmentRoles } from "./apis";

export const clearDepartment = (setFormData, setDepartmentRoleList) => {
  clearProperty("department", setFormData);
  clearProperty("departmentRole", setFormData);
  setDepartmentRoleList([]);
};

export const setEditData = (
  userData,
  setDepartmentRoleList,
  setFormData,
  setIsEmployee,
  setSelectedApps,
  setSelectedRoles,
  config,
  setConfig
) => {
  if (userData) {
    const {
      email,
      name,
      role,
      _id,
      limits,
      additionalRoles,
      department,
      departmentRole,
      isEmployee,
      vendor,
      activityStatus,
    } = userData;
    getAllDepartmentRoles({}, setDepartmentRoleList);
    const financeRoleMap = config.financeRoleList.reduce((uniqueMap, role) => {
      uniqueMap[role.value] = role.label;
      return uniqueMap;
    }, {});
    const financeV2RoleMap = config.financeV2RoleList.reduce((uniqueMap, role) => {
      uniqueMap[role.value] = role.label;
      return uniqueMap;
    }, {});

    const allRoles = additionalRoles?.reduce?.(
      ({ additionalRoleLst, financeRoleLst, financeV2RoleLst }, roleId) => {
        if (financeRoleMap[roleId]) {
          financeRoleLst.push(roleId);
        } else if (financeV2RoleMap[roleId]) {
          financeV2RoleLst.push(roleId);
        } else {
          additionalRoleLst.push(roleId);
        }
        return { additionalRoleLst, financeRoleLst, financeV2RoleLst };
      },
      { additionalRoleLst: [], financeRoleLst: [], financeV2RoleLst: [] }
    ) || { additionalRoleLst: [], financeRoleLst: [], financeV2RoleLst: [] };

    const { additionalRoleLst, financeRoleLst, financeV2RoleLst } = allRoles;

    setFormData({
      email,
      name,
      role,
      _id,
      additionalRoles: additionalRoleLst,
      financeRoles: financeRoleLst,
      financeV2Roles: financeV2RoleLst,
      department,
      departmentRole: departmentRole ? parseInt(departmentRole) : null,
      vendor,
      activityStatus,
    });

    setIsEmployee(isEmployee);

    let showFinanceConfig = false;
    let showFinanceV2Config = false;
    const rolesMap = {};
    const appList =
      limits?.map((item) => {
        const name = item?.app?.name || "";
        const value = item?.app?.id || "";
        if (parseInt(item?.app?.id) === parseInt(config.financeAppId)) {
          showFinanceConfig = true;
        }
        if (parseInt(item?.app?.id) === parseInt(config.financeV2AppId)) {
          showFinanceV2Config = true;
        }
        const roleId = item?.id;
        const roleName = item?.name;
        rolesMap[value] = { value: roleId, label: roleName };
        return { label: name, value: parseInt(value) };
      }) || [];
    setSelectedApps(appList);
    setSelectedRoles(rolesMap);
    setProperty(
      ["showFinanceConfig", "showFinanceV2Config"],
      [showFinanceConfig, showFinanceV2Config],
      setConfig
    );
  }
};
